<template>
    <main-content>
        <action-bar v-if="$can('create', 'store')">
            <router-link to="/stores/create" class="btn btn-success">{{ $t('store.btn.add') }}</router-link>
        </action-bar>
        <filter-bar></filter-bar>
        <kt-datatable v-bind="datatableProps"></kt-datatable>
    </main-content>
</template>

<script>
import { ApiUrl } from '@/common/api.service'
import columns from './datatable/columns'
import actions from './datatable/actions'
import { AuthorizationHeader } from '@/common/jwt.service'
import mainContent from '@/components/main-content'
import actionBar from '@/components/custom/action-bar'
import filterBar from '@/components/custom/filter-bar'

export default {
    components: {
        mainContent,
        actionBar,
        filterBar
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "store_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('store'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function(res) {
                                return res.data.data
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {
                },
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actions
            }
        }
    }
}
</script>

<style>

</style>